import { useState } from "react";

const faqs = [
  {
    q: "榜单里的热度和反转程度是怎么算出来的？",
    a: "劲爆大瓜榜围绕热度指数、反转程度与影响范围三个维度综合计算：热度参考全网讨论量与搜索趋势，反转程度参考事件剧情反复的次数，影响范围参考跨平台传播广度，三者加权后得到综合名次。",
  },
  {
    q: "年度榜和月度榜多久更新一次？",
    a: "年度最劲爆大榜于每年年初复盘上一年度全部热点后更新，月度最劲爆瓜榜则在每月月初更新，日常热瓜则通过顶部滚动与每日精选板块持续补充。",
  },
  {
    q: "我想看之前几期的瓜，能补课吗？",
    a: "可以。站内提供往期年榜与月榜的专题回顾入口，点击榜单标题旁的历史归档即可按时间倒序回看之前几期，方便一次性快速补课。",
  },
  {
    q: "榜单没有覆盖到的热点，怎么提交给我？",
    a: "如果你发现值得上榜却未被收录的热点，可通过页面底部联系方式向我们反馈线索，我们会在复核热度与来源可信度后，将其补充进下一期榜单。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section
      id="faq"
      className="scroll-mt-16 border-y border-background-200 bg-background-100/70 py-12 md:py-16"
    >
      <div className="mx-auto grid w-full max-w-7xl gap-8 px-4 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-bold tracking-widest text-secondary-800">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-serif text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            关于榜单的
            <br className="hidden lg:block" />
            那些疑问
          </h2>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            从榜单评分方法到更新频率，我们把最常见的几个问题整理在这里。如果仍有疑问，欢迎在页面底部留言。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="text-base font-bold text-foreground-950">{f.q}</h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i
                        className={`ri-add-line transition-transform ${
                          isOpen ? "rotate-45" : ""
                        }`}
                      ></i>
                    </span>
                  </button>
                  <div
                    className="grid transition-all duration-300"
                    style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}